// extracted by mini-css-extract-plugin
module.exports = {"link":"_3-x13","image":"_3ErHH","root":"_3vYzk"};